<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ chatTitle }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">

  <div class="chat">
    <div class="chat-line" *ngFor="let item of items; let i = index" [class.client]="item.fromClient">

      <!-- date delimiter -->
      <div *ngIf="item.dateDelimiter" class="date-delimiter">{{ item.createdAt | localeDate:locale:'MMMM dd' }}</div>

      <!-- message type -->
      <div *ngIf="item.itemType === chatItemType.Message" [class]="'message ' + getCorner(i)"
        [class.show-with-animation]="isAnimatedLastMessage && items.length === i + 1">
        <span *ngIf="!item.fromClient" class="username">{{ item.username }}</span>
        <div class="content">
          <div class="message-wrapper">
            <p *ngIf="item.title" [class]="'title ' + getTitleColor(item.style)">{{ item.title }}</p>
            <p *ngIf="item.message" class="text">{{ item.message }}</p>
          </div>
          <span class="date">{{ item.createdAt | date: 'HH:mm' }}</span>
        </div>
      </div>

      <!-- notice type -->
      <div *ngIf="item.itemType === chatItemType.Notice" [class.with-offset]="isOffset(i)" class="notice" [class.success]="item.style === 0"
        [class.warning]="item.style === 1" [class.danger]="item.style === 2">
        <div class="status">
          <ion-icon [name]="item.icon"></ion-icon>
        </div>
        <div class="content">
          <p *ngIf="item.title" class="title">{{ item.title }}</p>
          <p *ngIf="item.message" class="text">{{ item.message }}</p>
          <span class="date">{{ item.createdAt | date: 'HH:mm' }}</span>
        </div>
      </div>

      <!-- information type -->
      <div *ngIf="item.itemType === chatItemType.Information" class="information" [class.with-offset]="isOffset(i)">
        <div class="content-wrapper">
          <div class="status">
            <ion-icon [name]="item.icon"></ion-icon>
          </div>
          <span class="username">{{ item.username }}</span>
          <div class="content">
            <p class="title">{{ item.title }}</p>
            <p *ngIf="item.message" class="text">{{ item.message }}</p>
            <span class="extra">{{ item.extra }}</span>
          </div>
        </div>
        <span class="date">{{ item.createdAt | date: 'HH:mm' }}</span>
      </div>

    </div>
  </div>
</ion-content>

<ion-footer [translucent]="true">
  <rota-send-bar>
    <rota-requests-area area *ngIf="type === chatType.Requests" [applicationId]="id" [applicationTitle]="chatTitle" />
    <rota-enquiries-area area *ngIf="type === chatType.Enquiries" [applicationId]="id" [applicationTitle]="chatTitle" />
  </rota-send-bar>
</ion-footer>